import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSpacebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"spacebar"} maskId="square-filled-radius-0-stroke-1-IconSpacebar"><path d="M3 13V19H21V13H22V20H2V13H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSpacebar;
